module.exports = __webpack_public_path__ + "static/media/galerija_2021 (26).aeea5233.jpg";